<script>
import BaseCard from "../BaseCard";

export default {
  name: "EigenaarCard",
  extends: BaseCard,
  props: ["vz"],
  data: function() {
    return {
      header: "Eigendom en exploitatie",
      disabled: !this.hasPermission("update voorziening"),
      values: {
        eigendom_naam: this.vz.eigendom_naam,
        eigendom_type: this.vz.eigendom_type,
        exploitatie_naam: this.vz.exploitatie_naam,
        exploitatie_type: this.vz.exploitatie_type
      }
    };
  },
  computed: {
    schema: function() {
      return [
        {
          type: "text",
          name: "eigendom_naam",
          label: "Eigendom naam",
          placeholder: "Onbekend",
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "text",
          name: "eigendom_type",
          label: "Eigendom type",
          placeholder: "Onbekend",
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "text",
          name: "exploitatie_naam",
          label: "Exploitant naam",
          placeholder: "Onbekend",
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "text",
          name: "exploitatie_type",
          label: "Exploitant type",
          placeholder: "Onbekend",
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "editMode"
        },

        {
          type: "submit",
          "input-class": ["btn", "btn-blue", this.disabled ? "disabled" : ""],
          label: "Opslaan"
        }
      ];
    }
  },
  methods: {
    shorten_label: item => ({
      // TODO: this is a temp bug fix for size of field
      // We may be able to fix this with CSS
      // This impacts position of mobile nav
      ...item,
      label: item.label.slice(0, 20)
    }),
    submitHandler: async function(data) {
      const updatedVoorziening = data;
      const [ok, msg] = await this.$store.dispatch("updateVoorziening", {
        id: this.vz.id,
        properties: updatedVoorziening
      });
      this.parseResponse(ok, msg);
    }
  }
};
</script>
